export default __webpack_public_path__ + "static/media/media-details.f007ee26.png";